const variants = [
  { name: "default", container: "bg-slate-900/55 border-slate-700", accent: "border-indigo-500/35" },
  { name: "outline", container: "bg-transparent border-slate-500", accent: "border-indigo-500/35" },
  { name: "soft", container: "bg-slate-800/45 border-slate-600", accent: "border-indigo-500/35" },
];

export default variants;


